const SAUDI_MOBILE_REGEX = /^05\d{8}$/;
const PASSWORD_MIN_LENGTH = 8;

export function isValidPassword(password) {
  const value = String(password ?? "");

  if (value.length < PASSWORD_MIN_LENGTH) return false;
  if (!/[A-Z]/.test(value)) return false;
  if (!/[a-z]/.test(value)) return false;
  if (!/\d/.test(value)) return false;
  if (!/[^A-Za-z0-9]/.test(value)) return false;

  return true;
}

export function validatePasswordFields(
  password,
  passwordConfirmation,
  translate,
  { required = true } = {}
) {
  const pwd = String(password ?? "");
  const confirmation = String(passwordConfirmation ?? "");

  if (!required && !pwd && !confirmation) return null;

  if (!pwd) return translate("VALIDATION.password");
  if (!confirmation) return translate("VALIDATION.passwordConfirmation");

  if (pwd.length < PASSWORD_MIN_LENGTH) {
    return translate("VALIDATION.passwordLength");
  }

  if (!isValidPassword(pwd)) {
    return translate("VALIDATION.passwordComplexity");
  }

  if (pwd !== confirmation) {
    return translate("VALIDATION.notEqualPasswords");
  }

  return null;
}

export function validateFestivalProviderFields(
  mobile,
  commission,
  ownerName,
  password,
  passwordConfirmation,
  translate,
  { passwordRequired = true } = {}
) {
  if (!String(ownerName ?? "").trim()) {
    return translate("VALIDATION.owner_name");
  }

  const trimmedMobile = String(mobile ?? "").trim();

  if (!trimmedMobile) {
    return translate("VALIDATION.mobileRequired");
  }

  if (!SAUDI_MOBILE_REGEX.test(trimmedMobile)) {
    return translate("VALIDATION.phone_num");
  }

  if (commission !== null && commission !== undefined && String(commission).trim() !== "") {
    const commissionStr = String(commission).trim();

    if (!/^\d{1,3}$/.test(commissionStr)) {
      return translate("VALIDATION.commissionRange");
    }

    const value = Number(commissionStr);
    if (value < 0 || value > 100) {
      return translate("VALIDATION.commissionRange");
    }
  }

  return validatePasswordFields(password, passwordConfirmation, translate, {
    required: passwordRequired,
  });
}
